module.exports = __webpack_public_path__ + "img/Emmons.dd5dfb2b.jpeg";